<div>
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <app-table [rows]="rows" [columns]="columns" [actions]="tableActions" (action)="onAction($event)" (cellClick)="onCellClick($event)" (sort)="onSort($event)"
    (changeBatch)="onChangeBatch($event)" [batch]="true"></app-table>
  <div class="d-flex justify-content-between align-items-center my-15 has-pagination">
    <div class="pagination-left">
      <app-pagination *ngIf="totalCount > currentSize" [totalItems]="totalCount" [(currentPage)]="page" (change)="onPageChange($event)"
        [pageSize]="currentSize"></app-pagination>
    </div>

    <div class="d-flex align-items-center justify-content-end pagination-right">
      <span class="pagination-count">Showing {{ rows.length }} of {{ totalCount }} results</span>
      <ul *ngIf="sizes.length" class="pagination">
        <li *ngFor="let size of sizes" [ngClass]="{ active: size === currentSize }">
          <a (click)="changeSize($event, size)">{{ size }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #deleteModalTpl let-dialogRef="dialogRef">
  <deletemodal [message]="messageForModal" [dialogRef]="dialogRef"></deletemodal>
</ng-template>


<ng-template #shortCodeCreateEditModalTpl let-dialogRef="dialogRef">
  <div class="modal-header">
    <div class="modal-title">
      <h3>Create/Edit short code</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-mo-shortcode-form (onAfterSave)="onAfterSave($event)"></app-mo-shortcode-form>
  </div>
</ng-template>
